import React, { Component } from 'react';

class TextBox extends Component{
    constructor(props){
        super(props);
    }
    render(){
        let placeholderOtp=this.props.placeholder && this.props.placeholder==='ar'?'ادخل رمز التحقق':'Enter OTP here';
        let placeholderNationalId=this.props.placeholder && this.props.placeholder==='ar'?'يرجى ادخال رقم الهوية \\ الاقامة ':'Enter your ID/Iqama number';
        let placeholderIBAN=this.props.placeholder && this.props.placeholder==='ar'?'إدخال الهوية الوطنية':'Enter IBAN here';
        let placeholderPhone=this.props.placeholder && this.props.placeholder==='ar'?'إدخال الهوية الوطنية':'Enter Phone here';
        let placeholderRequest=this.props.placeholder && this.props.placeholder==='ar'?'أدخل رقم الطلب هنا':'Enter Request here';
        let placeholder=this.props.placeholder && this.props.placeholder==='ar'?'...أدخل رسالتك':'Type your message...';
        let classIs=this.props.id && this.props.id==='OTP'?('isOtp')
                    :this.props.id && this.props.id==='NationalId'?('isNationalId')
                    :this.props.id && this.props.id==='IBAN'?('isIBAN')
                    :this.props.id && this.props.id==='Phone'?('validMobile')
                    :this.props.id && this.props.id==='Account'?('validAccount')
                    :this.props.id && this.props.id==='Payment'?('validPayment')
                    :this.props.id && this.props.id==='Request'?('validRequest')
                    :this.props.id && this.props.id==='UDS'?('validUDS')
                    :'noOtp';
        return(
            <React.Fragment>
                {
                    this.props.id && (this.props.id==='Location' || this.props.id==='File')?
                    <label className="userLocation">{this.props.value}</label>
                    :
                    <input 
                        type={this.props.type}
                        value={this.props.value}
                        onChange={this.props.handleChange}
                        onKeyDown={this.props.handleKeydown}
                        disabled={this.props.disabled}
                        autoComplete={this.props.autocomplete}
                        id='usertext'
                        name='usertext'
                        placeholder={placeholder}
                        className={classIs}            
                    />
                }
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handleOtpChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='usertextt'
                    name='usertextt'
                    placeholder={placeholderOtp}
                    className={classIs}            
                />
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handleNationalIdChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='usertextnational'
                    name='usertextnational'
                    placeholder={placeholderNationalId}
                    className={classIs}            
                />
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handleIBANChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='userIBAN'
                    name='userIBAN'
                    placeholder={placeholderIBAN}
                    className={classIs}            
                />
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handlePhoneChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='userPhone'
                    name='userPhone'
                    placeholder={placeholderPhone}
                    className={classIs}            
                />
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handleReqNumChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='userRquest'
                    name='userRquest'
                    placeholder={placeholderRequest}
                    className={classIs}            
                />
                <input 
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.handleUDSNumChange}
                    onKeyDown={this.props.handleKeydown}
                    disabled={this.props.disabled}
                    autoComplete={this.props.autocomplete}
                    id='userUDS'
                    name='userUDS'
                    placeholder={placeholderRequest}
                    className={classIs}            
                />
            </React.Fragment>
        )
    }
}
TextBox.propTypes = {
    type: React.propTypes.node,
    value: React.propTypes.node,
    disabled: React.propTypes.node,
    autocomplete: React.propTypes.node,
    id: React.propTypes.node,
    name: React.propTypes.node,
    placeholder: React.propTypes.node,
    className: React.propTypes.node,
    handleChange: React.propTypes.node,
    handleOtpChange: React.propTypes.node,
    handleKeydown: React.propTypes.node,
    handleNationalIdChange: React.propTypes.node,
    handleNationalIdKeydown: React.propTypes.node
}
export default TextBox;